// extracted by mini-css-extract-plugin
module.exports = {"headerSection":"mainHeader_headerSection__E2mNN","headerLink":"mainHeader_headerLink__mPfRw","title":"mainHeader_title__zqKHX"};